var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('m-tab',{attrs:{"tabs":_vm.tabs,"active-tab":_vm.activeTab},on:{"update:activeTab":function($event){_vm.activeTab=$event},"update:active-tab":function($event){_vm.activeTab=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }